export const FILTER_TYPES = {
  DATE: 'DATE',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  TEXT: 'TEXT',
  SELECT_ENDPOINT: 'SELECT_ENDPOINT',
};
